class AdBlockDTO {
    constructor(params) {
        this.rank = params.rank;
        this.type = params.type;
        this.category = params.category;
        this.description = params.description;
        this.smallIcon = params.url + params.smallIcon;
        this.mediumIcon = params.url + params.mediumIcon;
        this.largeIcon = params.url + params.largeIcon;
        this.logo = params.url + params.logo;
        this.url = params.url;
    }
}
export default AdBlockDTO;
